document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.quantity').forEach(container => {
        const decrementButton = container.querySelector('.quantity__button--decrement');
        const incrementButton = container.querySelector('.quantity__button--increment');
        const quantityInput = container.querySelector('.input-group-field');

        decrementButton.addEventListener('click', () => {
            const currentValue = Number(quantityInput.value);
            if (currentValue > 0) {
                quantityInput.value = currentValue - 1;
            }
        });

        incrementButton.addEventListener('click', () => {
            const currentValue = Number(quantityInput.value);
            quantityInput.value = currentValue + 1;
        });
    });
});
document.addEventListener('DOMContentLoaded', function () {
    var lastScrollTop = 0;
    var scrollingDiv = document.getElementById('scrollingDiv');

    function handleScroll() {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (window.innerWidth < 991) {
            if (st > lastScrollTop && st > 150) {
                scrollingDiv.style.opacity = 1;
                scrollingDiv.style.display = "block";
            } else {
                scrollingDiv.style.opacity = 0;
                scrollingDiv.style.display = "none";
            }
        } else {
            scrollingDiv.style.display = "none";
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }

    window.addEventListener('scroll', handleScroll, false);

    handleScroll();
});

function openModal() {
    var modalShown = getCookie("modal_shown_form");

    if (modalShown !== "1") {
        document.getElementById('modalOverlay').style.display = 'block';
        setCookie("modal_shown_form", "1", 1);
    }
}

function closeModal() {
    document.getElementById('modalOverlay').style.display = 'none';
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

document.getElementById('closeModal').addEventListener('click', closeModal);

setTimeout(openModal, 10000);


document.addEventListener('click', function (event) {
    var navbar = document.getElementById('navbarNavDropdown');
    var navbarToggler = document.querySelector('.navbar-toggler');

    var isNavbarOpen = navbar.classList.contains('show');

    if (isNavbarOpen && !navbar.contains(event.target) && !navbarToggler.contains(event.target)) {
        navbar.classList.remove('show');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.read-more-link-reviews-button').forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            var reviewContent = this.closest('.review-content');
            reviewContent.classList.toggle('expanded'); 

            if (reviewContent.classList.contains('expanded')) {
                this.textContent = 'Czytaj mniej'; 
            } else {
                this.textContent = 'Czytaj więcej'; 
            }
        });
    });
});